import { useQuery } from '@apollo/client/react';
import { useState } from 'react';
import { GET_VERTRAEGE } from '../lib/graphql/queries';

export type Vertrag = {
  vertragsnummer: string;
  kundennummer: number;
  unternehmensname: string;
};

function gewaehlterVertrag(vertraege: Vertrag[], auswahl?: string) {
  if (auswahl) {
    return vertraege.find((vertrag) => vertrag.vertragsnummer === auswahl);
  }

  // Ein einzelner Vertrag ist vorausgewählt
  if (vertraege.length === 1) {
    return vertraege[0];
  }

  return undefined;
}

export function useVertragAuswahl(open: boolean) {
  const { data, loading } = useQuery(GET_VERTRAEGE, { skip: !open });
  const [auswahl, setAuswahl] = useState<string>();

  const vertraege =
    data?.aktivierung.__typename === 'Aktivierungszustand'
      ? data.aktivierung.vertraege
      : [];

  return {
    vertraege,
    vertrag: gewaehlterVertrag(vertraege, auswahl),
    waehle: setAuswahl,
    laedt: loading,
    keinVertrag: !loading && vertraege.length === 0,
  };
}
